import React from 'react';
import { Checkbox, Tooltip, Modal, Typography, useTooltip, Button } from '@vtblife/uikit';
import { OptionType, Toggle } from '@vtblife/uikit/legacy';
import Icon from '@vtblife/uikit-icons';

import classname from '@search/classname/src';

import { Rooms } from '@search/filter-enums/enums';
import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { KitchenAreaFilter, RoomFilter } from '../../../../models/Filter';

import './MobileRoomFilterCheckboxesView.css';

const cn = classname.bind(null, 'MobileRoomFilterCheckboxesView');

interface IMobileRoomFilter {
    filter: RoomFilter;
    kitchenAreaFilter: KitchenAreaFilter;
    handleChange: (filter: RoomFilter | KitchenAreaFilter) => void;
    classNameGroup?: string;
    classNameSeparate?: string;
    isRent?: boolean;
    isMap?: boolean;
}

const OPTIONS: OptionType<Rooms>[] = [
    { label: '1', value: Rooms.ROOM_1 },
    { label: '2', value: Rooms.ROOM_2 },
    { label: '3', value: Rooms.ROOM_3 },
    { label: '4', value: Rooms.ROOM_4 },
    { label: '5+', value: Rooms.ROOM_5_AND_MORE },
    { label: 'Студия', value: Rooms.STUDIO },
    { label: 'Свободная планировка', value: Rooms.OPEN_PLAN }
];

export const MobileRoomFilterButtonView: React.FC<IMobileRoomFilter> = ({
    filter,
    kitchenAreaFilter,
    handleChange,
    classNameGroup,
    classNameSeparate,
    isRent = false,
    isMap = false
}) => {
    const [ modal, setModal ] = React.useState(false);
    const [ toggle, setToggle ] = React.useState<boolean>(false);

    const { to, registerControl } = useTooltip();

    const onChange = React.useCallback((value: boolean, optionType: Rooms) => {
        const filters = new Set(filter.rooms);

        filters[value ? 'add' : 'delete'](optionType);

        if (filters.has(Rooms.STUDIO)) {
            setToggle(false);
            onChangeEuroPlan(false);
        }

        handleChange(new RoomFilter(Array.from(filters)));
    }, [ handleChange, filter.rooms, toggle ]);

    const onChangeEuroPlan = React.useCallback((value: boolean) => {
        setToggle(value && ! filter.rooms.includes(Rooms.STUDIO));
        value && ! filter.rooms.includes(Rooms.STUDIO) ?
            handleChange(new KitchenAreaFilter({ from: 15, to: null })) :
            handleChange(new KitchenAreaFilter({ from: null, to: null }));
    }, [ handleChange ]);

    const toggleNode = isMap ? (
        (
            <div className={cn('toggle')} ref={registerControl}>
                <Typography onClick={() => onChangeEuroPlan(! toggle)} variant='primary-alone'>
                    Только европланировки
                    <span style={{ marginLeft: 8 }}>
                        <Icon
                            name='question-circle'
                            color='#746D9380'
                            size='m'
                        />
                    </span>
                </Typography>
                <Toggle
                    value={toggle || ((kitchenAreaFilter?.value?.from ?? 0) >= 15)}
                    onChange={onChangeEuroPlan}
                    disabled={filter.rooms.includes(Rooms.STUDIO)}
                />
                <Tooltip placement='body' to={to}>
                    Показывать только квартиры с&nbsp;совмещённой кухней-гостинной
                </Tooltip>
            </div>
        )
    ) : (
        <div className={cn('toggle')}>
            <Typography variant='primary-alone'>
                Только европланировки
                <span style={{ marginLeft: 8 }} onClick={() => setModal(true)}>
                    <Icon
                        name='question-circle'
                        color='#746D9380'
                        size='m'
                    />
                </span>
            </Typography>
            <Toggle
                value={toggle || ((kitchenAreaFilter?.value?.from ?? 0) >= 15)}
                onChange={onChangeEuroPlan}
                disabled={filter.rooms.includes(Rooms.STUDIO)}
            />
        </div>
    );

    return (
        <MobileFilter2 filterTitle='Комнат'>
            <div>
                <div className={classNameGroup}>
                    {OPTIONS.map(({ label, value }) => (
                        <div key={value} style={{ minWidth: '60px' }}>
                            <Checkbox
                                name={label}
                                value={filter.rooms.includes(value)}
                                onChange={v => onChange(v, value)}
                                variant='filter'
                                block
                            >
                                {label}
                            </Checkbox>
                        </div>
                    ))}
                </div>
                {isRent ? null : toggleNode}
            </div>
            {! isMap ? (
                <Modal
                    size='s'
                    opened={modal}
                    onClose={() => setModal(false)}
                >
                    <Typography variant='primary-alone' bold>
                        Европланировка
                    </Typography>
                    <Typography variant='primary-alone' className={classNameSeparate}>
                        Показывать только квартиры с&nbsp;совмещённой кухней-гостинной
                    </Typography>
                    <Button variant='secondary' fullWidth onClick={() => setModal(false)}>
                        Свернуть
                    </Button>
                </Modal>
            ) : null}
        </MobileFilter2>
    );
};
